export default __webpack_public_path__ + "static/media/03-healthcare.d3df08cb.jpg";